import StaticRegister from '@utils/static_register.js'

const { register, getItem } = new StaticRegister('editors')

export function _register(name, editor) {
  register(name, editor)
}

function proxyGetItem(name) {
  return getItem(name)
}

function proxyRegister(name, editor) {
  if (typeof name !== 'string') {
    editor = name
    name = editor.EDITOR_TYPE
  }
  register(name, editor)
}

export { proxyRegister as registerEditor, proxyGetItem as getEditor }
